import {create} from 'zustand';
import {contentSubmissionOffPlatformIdentityActions} from '@/stores/contentSubmissionOffPlatformIdentityStore';

export interface UserIdentity {
  name: string;
  email: string;
  role: string;
}

type ContentSubmissionOffPlatformReviewState = {
  campaignId: string | undefined;
  userIdentity: UserIdentity | null;
  pendingIdentity: UserIdentity | null;
  isEditingIdentity: boolean;
};

const contentSubmissionOffPlatformReviewStore =
  create<ContentSubmissionOffPlatformReviewState>(() => ({
    campaignId: undefined,
    userIdentity: null,
    pendingIdentity: null,
    isEditingIdentity: false,
  }));

const initReview = (campaignId: string) => {
  const identity =
    contentSubmissionOffPlatformIdentityActions.getIdentity(campaignId);
  contentSubmissionOffPlatformReviewStore.setState({
    campaignId,
    userIdentity: identity,
    pendingIdentity: null,
    isEditingIdentity: false,
  });
};

const resetReview = () =>
  contentSubmissionOffPlatformReviewStore.setState({
    campaignId: undefined,
    userIdentity: null,
    pendingIdentity: null,
    isEditingIdentity: false,
  });

const setUserIdentity = (identity: UserIdentity) => {
  const {campaignId} = contentSubmissionOffPlatformReviewStore.getState();
  contentSubmissionOffPlatformReviewStore.setState({userIdentity: identity});
  if (campaignId) {
    contentSubmissionOffPlatformIdentityActions.setIdentity(
      campaignId,
      identity
    );
  }
};

const setPendingIdentity = (identity: UserIdentity | null) =>
  contentSubmissionOffPlatformReviewStore.setState({
    pendingIdentity: identity,
  });

const setIsEditingIdentity = (editing: boolean) =>
  contentSubmissionOffPlatformReviewStore.setState({
    isEditingIdentity: editing,
  });

export const contentSubmissionOffPlatformReviewActions = {
  initReview,
  resetReview,
  setUserIdentity,
  setPendingIdentity,
  setIsEditingIdentity,
};

export default contentSubmissionOffPlatformReviewStore;
